import { render, staticRenderFns } from "./myComplaintsTable.vue?vue&type=template&id=78d2924b"
import script from "./myComplaintsTable.vue?vue&type=script&lang=js"
export * from "./myComplaintsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports